<template>
	<Tooltip
		:trigger-tab-index="0"
		v-if="deactivated"
		:content="$t('application.profile-deactivated.explanation')"
	>
		<Badge color="subtle" variant="smallStatusTag">
			<img
				src="/icons/applicant-profile-deactivated.svg"
				alt=""
				class="w-3.5 h-3.5 shrink-0"
			/>
			{{ $t('application.profile-deactivated.badge') }}
		</Badge>
	</Tooltip>
</template>

<script>
import Badge from '~/components/ui/common/Badge.vue'
import Tooltip from '~/components/Tooltip/Tooltip.vue'
import { isApplicationProfileDeactivated } from '~/utils/applicationAvailability'

export default {
	name: 'ApplicantProfileDeactivatedBadge',
	components: { Badge, Tooltip },
	props: { application: { type: Object, default: null } },
	computed: {
		deactivated() {
			return isApplicationProfileDeactivated(this.application)
		}
	}
}
</script>
